import { Anchor, Breadcrumbs, Card, Grid } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import AssetForm from '../../components/Assets/AssetForm';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import Spinner from '../../components/Spinner';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';

const page = `${Page['assets']}`;

const AssetsDetailsPage = () => {
  const fetch = useFetch();
  const navigate = useNavigate();
  const location = useLocation();

  const { accountId, domainId, assetId } = useParams();
  const [asset, setAsset] = useState();
  const [userError, setUserError] = useState();
  const [loadError, setLoadError] = useState();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/assets/${assetId}`)
      .then(({ asset }) => {
        if (!asset) {
          navigate(`/accounts/${accountId}/domains/${domainId}/assets`);
        }
        setAsset(asset);
      })
      .catch(setLoadError);
  }, [fetch, navigate, accountId, domainId, assetId]);

  const update = (asset) => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/assets/${assetId}`, {
      method: 'PUT',
      body: JSON.stringify({ asset }),
    })
      .then(() => {
        navigate(location.pathname.replace(`/assets/${asset.id}`, '/assets'));
      })
      .catch(setUserError);
  };

  const del = (cb) => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/assets/${assetId}`, {
      method: 'DELETE',
    })
      .then(() => {
        if (typeof cb === 'function') {
          cb();
        }
        navigate(location.pathname.replace(`/assets/${asset.id}`, '/assets'));
      })
      .catch(setLoadError);
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (!asset) {
    return <Spinner />;
  }

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/assets` },
    { title: 'Edit' },
  ].map((item, index) => (
    <Anchor href={item.href} key={index}>
      {item.title}
    </Anchor>
  ));

  return (
    <>
      <Metadata title={`${page} | ${asset.title} | Edit`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>
      <Grid>
        <Grid.Col span={12}>
          <Card withBorder>
            <AssetForm
              asset={asset}
              saveAsset={(asset) => {
                update(asset);
              }}
              deleteAsset={(cb) => del(cb)}
              closeModal={null}
            />
          </Card>
        </Grid.Col>
      </Grid>
      {userError ? (
        <div style={{ textAlign: 'right' }}>
          <ErrorMessage message={userError.message} />
        </div>
      ) : null}
    </>
  );
};

export default AssetsDetailsPage;
